module.exports = __webpack_public_path__ + "img/logo.95f85788.svg";